module.exports = __webpack_public_path__ + "static/media/signature.f94acd47.png";